




















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Icon, Toast } from "vant";
import request from "@/api/index";
import "@/common/calendar.scss";
@Component({
  components: {
    vanIcon: Icon
  }
})
export default class Calendar extends Vue {
  @Prop()
  private toDate!: string;
  public request = new request();
  selected: number | string = "";
  weeks = ["日", "一", "二", "三", "四", "五", "六"]; // 星期排序
  mymonths = "2023-01"; // 当前所在月份
  mydays: any = []; // 每月天数 通过当前月份算得
  myWeek: string | number = "";
  isNewsInfo: any = [];
  mounted() {
    if (this.toDate) {
      this.mymonths = this.toDate.substr(0, 7);
    } else {
      let time = new Date();
      let month: number | string = Number(time.getMonth()) + 1;
      month = month < 10 ? "0" + month : month;
      this.mymonths = time.getFullYear() + "-" + month;
    }
    this.$nextTick(() => {
      this.selected = this.toDate;
    });
  }
  async getDayAndWeek() {
    let mytime = new Date(this.mymonths);
    // console.log(mytime.getFullYear(),mytime.getMonth()+1,);
    // 根据当前月份 获取当前月份的天数 是30 还是31
    this.mydays = new Date(
      mytime.getFullYear(),
      mytime.getMonth() + 1,
      0
    ).getDate();
    // 根据当前月份 获取当前月份一号星期几
    this.myWeek = new Date(mytime + "-1").getDay();
    let res = await this.request.getMonthsList(
      (this as any).$route.query.appId,
      this.mymonths
    );

    if (res.code == 0) {
      this.isNewsInfo = res.data;
    } else {
      this.isNewsInfo = [];
      for (let i = 0; i < Number(this.mydays); i++) {
        this.isNewsInfo.push({ isNews: 0 });
      }
    }
  }
  // 月份切换 val==1 -- val==2 ++
  Monthchange(val: any) {
    let mytime = new Date(this.mymonths);
    // -- 月份
    if (val == 1) {
      if (mytime.getMonth()) {
        //  != 0  前一月
        this.mymonths = `${mytime.getFullYear()}-${
          mytime.getMonth() < 10 ? "0" + mytime.getMonth() : mytime.getMonth()
        }`;
      } else {
        // 月份 == 0后切换到上前一年的12月
        this.mymonths = `${mytime.getFullYear() - 1}-12`;
      }
    } else {
      // ++ 月份
      if (mytime.getMonth() == 11) {
        // 月份满 11 后年份加 一 月份变成 1 月
        this.mymonths = `${mytime.getFullYear() + 1}-01`;
      } else {
        // 月份 正常 ++
        this.mymonths = `${mytime.getFullYear()}-${
          mytime.getMonth() + 2 < 10
            ? "0" + (mytime.getMonth() + 2)
            : mytime.getMonth() + 2
        }`;
      }
    }
    this.getDayAndWeek(); // 刷新日历
  }
  changeDate(day: any, isData: any) {
    if (isData) {
      let day2 = day < 10 ? "0" + day : day;
      let date = this.mymonths + "-" + day2;
      this.selected = date;
      this.$emit("changeDate", 2, date);
    } else {
      Toast("该日期没有新闻数据，请重新选择！");
    }
  }
  cancel() {
    this.$emit("changeDate", 1);
  }
}
